/**
 * This class provides utility functions.
 */
export class AllyUtil {
    /**
     * This function executes the provided callback.
     * 
     * If the condition is True the execution of the callback will be delayed until the call stack is empty.
     * 
     * @param condition The condition that must be true for the execute of the callback to be delayed.
     * @param callback The callback to be executed.
     */
    public static delay(condition: boolean, callback: () => void) {
        if (condition) {
            setTimeout(() => {
                callback();
            }, 0);
        } else {
            callback();
        }
    }
    /**
     * This function is a replacement for the forEach loop.
     * 
     * It creates a shallow copy of the list to be loop through before looping not through said list but through the copy.
     * 
     * The list can thus be modified during the loop.
     * 
     * @param list The list to be looped through.
     * @param callback The callback to be executed.
     */
    public static forEach<Type>(list: Type[], callback: (element: Type) => void) {
        let localList: Type[] = [...list];
        localList.forEach((element) => {
            callback(element);
        });
    }
}